import React, { useEffect } from "react";
import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
	resetHireSession,
	installResetHireSessionGlobal,
} from "../../utils/resetHireSession";

const useStyles = makeStyles(() => ({
	root: {
		position: "fixed",
		right: 16,
		bottom: 16,
		zIndex: 99999,
		backgroundColor: "#1a1a1a",
		color: "#fff",
		textTransform: "none",
		fontFamily: '"Instrument Sans", Helvetica, Arial, sans-serif',
		fontSize: 12,
		fontWeight: 600,
		padding: "8px 12px",
		borderRadius: 8,
		boxShadow: "0 4px 16px rgba(0,0,0,0.25)",
		"&:hover": {
			backgroundColor: "#333",
		},
	},
}));

const isLocalDev =
	typeof window !== "undefined" &&
	(window.location.hostname === "localhost" ||
		window.location.hostname === "127.0.0.1");

/**
 * Botón flotante solo en localhost para resetear el flujo de contratación.
 * También instala window.__resetHireSession() en la consola.
 */
const DevResetHire = () => {
	const classes = useStyles();

	useEffect(() => {
		if (!isLocalDev) return undefined;
		installResetHireSessionGlobal();
		return undefined;
	}, []);

	if (!isLocalDev) return null;

	const handleClick = () => {
		const ok = window.confirm(
			"¿Resetear flujo de contratación?\n\nSe borran token, persist de hire e IndexedDB y volvés al cotizador."
		);
		if (!ok) return;
		resetHireSession();
	};

	return (
		<Button
			type="button"
			className={classes.root}
			onClick={handleClick}
			title="También: window.__resetHireSession() en consola"
		>
			Reset hire
		</Button>
	);
};

export default DevResetHire;
